import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'

if (window && !window.__PRERENDER_INJECTED) {
  Vue.use(VueYouTubeEmbed, { global: true, componentId: 'youtube-embed' })
}
